<div class="main-div">
    <div class="col-12  flex flex-wrap">
        <h2>درختکاری</h2>
        <div class="col-12">
            <p>
                یزد به عنوان یکی از قطبهای صنعتی کشور و با توجه به اقلیم خشک و کویری آن نیازمند توجه ویژه به منابع طبیعی و محیط زیست است.
                برای داشتن «یزد پایدار» و در راستای رسالت اجتماعی سرچیا؛ نهالی را به یادگار از طرف شما به زمین و آیندگان هدیه کردیم.
            </p>
        </div>
        <div class="col-12 ">
            <!--            <video width="100%" controls>-->
            <!--                <source src="{{conf.getBaseUrl()+'lnd/file/stream-video-file?name=golkari.mp4' }}"-->
            <!--                        type="video/mp4">-->
            <!--            </video>-->


            <div class="h_iframe-aparat_embed_frame"><span style="display: block;padding-top: 57%"></span>
                <iframe src="https://www.aparat.com/video/video/embed/videohash/mijj3e4/vt/frame" allowFullScreen="true"
                        webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
            </div>
        </div>
    </div>
</div>